import React, { CSSProperties, FC } from 'react';
import { Tooltip, TooltipProps, Typography } from 'antd';
import styled from 'styled-components';
import { ExclamationCircleFilled } from '@ant-design/icons';

import colors from '~/constants/colors';
import { HintIcon } from '~/img';
import { useDirection } from '~/hooks/i18nHooks';
import { Direction } from '~/types/Direction';

export interface HintProps {
  text: TooltipProps['title'];
  width?: number;
  type?: any;
}
const CustomTooltip: FC<HintProps> = (props) => {
  const { text, width = 180, type } = props;
  const dir = useDirection();
  return (
    <Container type={type} width={width} className="Hint">
      <div className="tooltip">
        <span className="tooltiptext">
          <Typography.Paragraph className="textTypho">{text}</Typography.Paragraph>
        </span>
      </div>
      {type === 'error' ? (
        <ExclamationCircleFilled style={{ fontSize: '18px', color: 'red' }} />
      ) : (
        <HintIcon className="Hint-HintIcon" dir={dir} />
      )}
    </Container>
  );
};

const Container = styled.div<any>`
  color: black;
  .textTypho {
    margin: 6px;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
    border: 2px 2px black solid;
    padding: 10px;
  }
  .Hint-HintIcon {
    color: ${colors.blue[800]};
    font-size: 16px;
  }

  .tooltip .tooltiptext {
    border: ${({ type }) => {
      if (type === 'error') {
        return `.5px solid ${colors.red[1100]}`;
      }
      return `1px solid ${colors.blue[400]}`;
    }};
    /* visibility: hidden; */
    width: ${({ width }) => width}px;
    /* padding: '8px 10px'; */
    border: 10px 2px ${colors.blue[800]} solid;
    background-color: ${colors.blue[100]};
    box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;

    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 0px;
    margin-left: 40px;
    /* left: 110%; */
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 10%;
    right: 100%;
    /* margin-top: -2%; */
    border-width: 8px;
    border-style: solid;
    border-color: ${({ type }) => {
      if (type === 'error') {
        return `transparent ${colors.red[800]} transparent transparent`;
      }
      return `transparent ${colors.blue[400]} transparent transparent`;
    }};
  }
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;

export default CustomTooltip;
